// useMainPlate.ts
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useUIStore } from "../store";
import { getAssetUrl } from "../utils/getAssetUrl";
import { Product } from '../interfaces/domain/menu';

export const useMainPlate = (plate: Product) => {
  const navigate = useNavigate();

  const imagesVersion = useUIStore((s) => s.config.imagesVersion);
  const placeholder = useUIStore((s) => s.config.placeholder_url);

  const imageUrl = useMemo(() => {
    return getAssetUrl(plate.image_url, { imagesVersion, placeholder_url: placeholder });
  }, [plate.image_url, imagesVersion, placeholder]);

  const setSection = useUIStore(s => s.setSection);

  const openModal = useCallback(() => {
    setSection("productModal"); // 🔥 CLAVE
    navigate(`?product=${plate.id}`);
  }, [navigate, plate.id]);

  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      openModal();
    }
  }, [openModal]);

  return {
    imageUrl,
    placeholder,
    openModal,
    handleKeyDown
  };
};